import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonListDialogComponent } from './button-list-dialog/button-list-dialog.component';
import {MatDialogModule} from '@angular/material/dialog';
import {TranslateModule} from '@ngx-translate/core';
import {MatIconModule} from '@angular/material/icon';
import {FuseSharedModule} from 'fuse-core/shared.module';
import {MatButtonModule} from '@angular/material/button';



@NgModule({
  declarations: [
    ButtonListDialogComponent
  ],
    imports: [
        CommonModule,
        MatDialogModule,
        TranslateModule,
        MatIconModule,
        FuseSharedModule,
        MatButtonModule
    ]
})
export class ButtonListModule { }